// ─── Shared constants and pure helpers for the Users view ────────────────────

export { LICENSE_TIERS, PAGE_SIZES } from './shared.constants.js';

// ── Filter options ────────────────────────────────────────────────────────────

export const FILTER_DEFAULTS = {
  licenseTiers: [],
  promptsMin:   '',
  promptsMax:   '',
  dateFrom:     '',
  dateTo:       '',
};

export function countActiveFilters(f) {
  let count = 0;
  if (f.licenseTiers.length > 0)                 count++;
  if (f.promptsMin !== '' || f.promptsMax !== '') count++;
  if (f.dateFrom   !== '' || f.dateTo    !== '') count++;
  return count;
}

// ── Column definitions ────────────────────────────────────────────────────────

export const COLS = [
  { key: 'name',                    label: 'Name',                    sortable: true  },
  { key: 'email',                   label: 'Email',                   sortable: true  },
  { key: 'account_name',            label: 'Account',                 sortable: true  },
  { key: '_date_created_str',       label: 'Date Created',            sortable: true  },
  { key: 'license',                 label: 'License',                 sortable: false },
  { key: 'practice_areas',          label: 'Practice Areas',          sortable: false },
  { key: 'latest_prompts_per_month',label: 'Latest Prompt/mo',        sortable: true  },
  { key: 'fingerprint_count',       label: 'Fingerprint Count',       sortable: false },
  { key: 'average_monthly_iPs',     label: 'Average Monthly IPs',     sortable: false },
  { key: 'average_monthly_devices', label: 'Average Monthly Devices', sortable: false },
  { key: '_actions',                label: 'Actions',                 sortable: false },
];

// ── UI strings ────────────────────────────────────────────────────────────────

export const STRINGS = {
  // Page
  pageTitle:    'Users',
  pageSubtitle: 'Manage and monitor all users',

  // Search / table
  searchPlaceholder: 'Search by name or email...',
  emptyMessage:      'No users found.',

  // Filters panel
  filtersBtn: 'Filters',
  clearAll:   'Clear all',
  apply:      'Apply',

  // Filter section labels
  licenseSectionLabel: 'License tier',
  promptsSectionLabel: 'Latest prompts / mo',
  dateSectionLabel:    'Date created',
  ipsSectionLabel:     'Avg monthly IPs',
  dateFrom:            'From',
  dateTo:              'To',

  // Kebab actions
  kebabMail:   'Mail',
  kebabDelete: 'Delete',

  // Delete modal
  deleteModalTitle: 'Delete User',
  deleteModalBtn:   'Delete User',
};
